export default __webpack_public_path__ + "static/media/mobile.f2b5a799.png";